import mustache from '../../../../1-Editweb/App/Admin/resources/js/classes/mustache.min.js';
window.Mustache = mustache;

import './init.js';
import './classes/Aj.js';
import './classes/Form.js';
import './classes/Notify.js';
import './classes/Spin.js';


$(document).ready(function(){

    $('[data-burger]').on('click', function () {
        if ($(this).children().hasClass('is-active')) {
            $(this).children().removeClass('is-active');
            $('.leftbar').removeClass('open');
        } else {
            $(this).children().addClass('is-active');
            $('.leftbar').addClass('open');
        }
    })

    $('html').on('click', '[data-href]', function () {
        window.location.href = $(this).attr('data-href');
    })

    $('html').on('click', '[data-info-clienti]', function () {
        $('[data-info-clienti-tooltip]').fadeToggle();
    })

    Fancybox.bind("[data-fancybox]", {
        // Your custom options
    });

    $('html').on('click', '[data-help]', function(){
        var help = $('[data-help-bar]');
        help.fadeIn().promise().done(function(){
            help.find('.help-bar__content').addClass('open');
        });
    })

    $('html').on('click', '[data-help-bar-close]', function(){
        var help = $('[data-help-bar]');
        $('.help-bar__content').removeClass('open').promise().done(function(){
            help.fadeOut();
        });
    })

    $('[data-select]').select2({
        //allowClear: true,
        language: "it"
    });

    $('html').on('click', '[data-user]', function () {
        $('[data-user-menu]').slideToggle();
        $('[data-notifiche-menu]').slideUp();
    })

    $('html').on('click', '[data-notifiche]', function () {
        $('[data-notifiche-menu]').slideToggle();
        $('[data-user-menu]').slideUp();
    })

    $('html').on('click', '[data-select-vista]', function () {
        $('[data-select-vista-menu]').slideToggle();
    })

    $('html').on('click', '[data-select-vista-item]', function () {
        $('[data-select-vista-label]').text($(this).text());
    })

    $('html').on('click', '[data-crea]', function () {
        $('[data-crea-menu]').slideToggle();
    })

    $('html').on('click', '[data-remove-scadenza]', function () {
        $(this).parent().remove();
    })

    $('.form-group input, .form-group textarea').focus(function(){
        $(this).parents('.form-group').addClass('focused');
    });

    $('.form-group input, .form-group textarea').blur(function(){
        var inputValue = $(this).val();
        if ( inputValue == "" ) {
           // $(this).removeClass('filled');
            $(this).parents('.form-group').removeClass('focused');
        } else {
            //$(this).addClass('filled');
        }
    })

    $('html').on('click', '[data-select-all]', function(){
        var ID = $(this).attr('data-select-all');
        var type = $(this).attr('data-type')
        if(type === 'select'){
            //$('#'+ID).select2('destroy').find('option').prop('selected', 'selected').end().select2();
            $('#'+ID).select2('destroy')
            $('#'+ ID +' > option').each(function(){
                var VALUE = $(this).attr('value');
                if(VALUE != ''){
                    $(this).prop('selected', 'selected')
                }
                console.log(VALUE);
            });
            $('#'+ID).select2();
            //$('#'+ID).trigger("change");
            $(this).find('span').text('Deseleziona tutti');
            $(this).find('img').attr('src', '/assets/img/icone/ics.svg');
            $(this).attr('data-type', 'unselect');
        }
        else{
            console.log('entra');
            $('#'+ID).select2('destroy').find('option').prop('selected', false).end().select2();
            //$('#'+ID).trigger("change");
            $(this).find('span').text('Seleziona tutti');
            $(this).find('img').attr('src', '/assets/img/icone/okok.svg');
            $(this).attr('data-type', 'select');
        }

    })

    $('#datepicker').datepicker({
        format: "dd/mm/yyyy",
        language: "it",
        orientation: "bottom",
    });

    $('#datepicker').datepicker().on('changeDate', function (ev) {
        console.log(ev);
        let formatedDate = ev.format(0, "dd/mm/yyyy");
        let classe = formatedDate.replace(/\//g, '');
        window.AddData(formatedDate, classe);

    });

    $('#datepicker_single').datepicker({
        format: "dd/mm/yyyy",
        language: "it",
        orientation: "bottom",
    });

    window._addData = $('html').on('click', '[data-add-data]', function () {
        let data = $('#datepicker').val();
        let classe = data.replace(/\//g, '');
        if (data == '') {
            Notify.toastError('Seleziona una data');
        } else if ($('.data_' + classe).length > 0) {
            Notify.toastError('La data è già presente');
        } else {
            window.AddData(data, classe);
        }

    })

    $('html').on('click', '[data-show-password]', function(){
        let ID = $(this).attr('data-show-password');
        let password = $(ID);
        const type = password.attr('type') === 'password' ? 'text' : 'password';
        password.attr('type', type);
        $(this).toggleClass('with-slash');
    })

    $('html').on('click', '[data-copy-to-clipboard]', function(){
        navigator.clipboard.writeText(window.location.href);
        Notify.toastSuccess('Link copiato');
    })

    $('html').on('click', '[data-gtag]', function(){
        let name_event = $(this).attr('data-gtag');
        let cookie = getCookie('ck_po');
        // gtag è definito da cookie-policy.js (GA4_init): l'evento va nel dataLayer e lo legge GTM
        if(cookie != '' && typeof window.gtag === 'function'){
            window.gtag('event', name_event, {});
        }
    })

    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
})
